import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { UiComponents } from "@simulanisindia/ui";
import BtnLoad from "../common/BtnLoad";
import { AddProjectLightIcon, DeleteIcon, EditIcon } from "../../Assest/icons/icons";

const { SimInputBar } = UiComponents;

const AddScenarioModal = ({ showScenario, handleCloseScenario, handleSaveScenario, scenarioList, updateTaskListDeleteScenario }) => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [error, setError] = useState(null);
  const [updateScenarioId, setUpdateScenarioId] = useState(null);

  const closeModal = () => {
    setLoading(false);
    if (typeof handleClose === "function") handleClose();
  };

  const handleClose = () => {
    setName("");
    setError(null);
    setUpdateScenarioId(null);
    handleCloseScenario();
  }

  const createScenario = () => {
    setError(null);
    if (name.trim().length > 0) {
      if (scenarioList.length > 0) {
        let maxNumber = Math.max(...scenarioList.map(item => item.id))
        handleSaveScenario([...scenarioList, {
          id: Number(maxNumber + 1),
          name: name
        }]);
      } else {
        handleSaveScenario([{
          id: Number(1),
          name: name
        }]);
      }
      setName("");
      return
    }
    setError("kindly fill name");
  }

  const updateScenario = () => {
    setError(null)
    if (name.trim().length > 0) {
      let updatedScenario = scenarioList.map((e) => e.id == updateScenarioId ? { id: e.id, name: name } : e);
      handleSaveScenario(updatedScenario);
      setName("");
      setUpdateScenarioId(null);
      return
    }
    setError("kindly fill name")
  }

  const handleEditScenario = (e) => {
    setUpdateScenarioId(e.id);
    setName(e.name);
  }

  const handleDeleteScenario = (e) => {
    let findIndex = scenarioList.findIndex(f => f.id == e.id)
    if (findIndex > -1) {
      scenarioList.splice(findIndex, 1);
      handleSaveScenario(scenarioList);
      updateTaskListDeleteScenario(e.id)
    }
  }

  return (
    <Modal show={showScenario} centered onHide={closeModal} className="createModal">
      <div className="customModalHead">
        <div className="filterbtn">
          <div className="btninadjust">
            <AddProjectLightIcon />
          </div>
        </div>
        <h6>Add Scenario</h6>
      </div>
      <Modal.Body>
        <div className="projectCreation">
          <div className="inputItem">
            <p>Scenario Name</p>
            <SimInputBar
              placeholder="Enter Scenario Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {error && <p className="small text-muted px-1">{error}</p>}
          </div>
        </div>
      </Modal.Body>
      <div className="modalFooterB">
        <button className="cancel" onClick={handleClose}>
          Close
        </button>
        {updateScenarioId ?
        <button className="save" onClick={updateScenario}>
          {loading ? <BtnLoad /> : "Update"}
        </button>
        :
        <button className="save" onClick={createScenario}>
          {loading ? <BtnLoad /> : "Add"}
        </button>}
      </div>

      <div className='row align-items-center'>
        {scenarioList.length > 0 &&
          <div className='col-md-12'>
            <table>
              <thead>
                <tr>
                  <th>S.n</th>
                  <th>Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              {scenarioList.map((f, i) => {
                return (
                  <tbody>
                    <tr>
                      <td>{i + 1}</td>
                      <td>{f.name}</td>
                      <td>
                        <span className='pointer m-4' onClick={() => handleEditScenario(f)} > <EditIcon /> </span>
                        <span className='pointer' onClick={() => handleDeleteScenario(f)} > <DeleteIcon /> </span>
                      </td>
                    </tr>
                  </tbody>
                )
              })}
            </table>
          </div>
        }
      </div>


    </Modal>
  );
};

export default AddScenarioModal;